module.exports = __webpack_public_path__ + "img/1544762487.02faf7df.jpg";